import { SopCategory } from 'components/sop/sop-category/SopCategory'
import { useEffect, useState } from 'react'
import { useLocation, useSearchParams } from 'react-router-dom'
import { API_SOP_CATEGORY } from 'services/apiSopCategory'
import { useFetch } from 'services/useFetch'
import { getAllQueryParams, setQueryParams } from 'utils/utils'
import { ACTION_TYPE } from 'constants/constant'
import { INITIAL_DATA_QUERY_SOP_CATEGORY } from 'configs/sop/configTableSopCategory'

const INITIAL_FORM_VALUE = {
    name: '',
}

export const SopCategoryContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_QUERY_SOP_CATEGORY

    const [formValue, setFormValue] = useState(INITIAL_FORM_VALUE)
    const [actionType, setActionType] = useState(ACTION_TYPE.CREATE)
    const [editId, setEditId] = useState(null)
    const [deleteId, setDeleteId] = useState(null)
    const [selectedItems, setSelectedItems] = useState([])
    const [modal, setModal] = useState({
        form: false,
        delete: false,
        limit: false,
    })
    const [toast, setToast] = useState({
        isShowToast: false,
        message: '',
    })

    const {
        data: sopCategoryList,
        fetching: getSopCategoryList,
        isLoading,
    } = useFetch(API_SOP_CATEGORY.LIST)

    const { fetching: createSopCategory, isLoading: isCreating } = useFetch(API_SOP_CATEGORY.CREATE)
    const { fetching: updateSopCategory, isLoading: isUpdating } = useFetch(API_SOP_CATEGORY.UPDATE)
    const { fetching: deleteSopCategory, isLoading: isDeleting } = useFetch(API_SOP_CATEGORY.DELETE)

    useEffect(() => {
        fetchSopCategoryList()
    }, [location?.search])

    const fetchSopCategoryList = () => {
        getSopCategoryList({ ...query })
    }

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const clearToast = () => {
        setToast({ isShowToast: false, message: '' })
    }

    const showToast = (message) => {
        setToast({ isShowToast: true, message })
    }

    const onChangeName = (e) => {
        setFormValue((prev) => ({
            ...prev,
            name: e?.value ?? e?.target?.value ?? '',
        }))
    }

    const onCreateHandler = () => {
        setActionType(ACTION_TYPE.CREATE)
        setEditId(null)
        setFormValue(INITIAL_FORM_VALUE)
        setModal((prev) => ({ ...prev, form: true }))
    }

    const onClickItemHandler = ({ item, actionType: type }) => {
        if (type === ACTION_TYPE.EDIT) {
            setActionType(ACTION_TYPE.EDIT)
            setEditId(item?.id)
            setFormValue({
                name: item?.name || '',
            })
            setModal((prev) => ({ ...prev, form: true }))
        } else if (type === ACTION_TYPE.DELETE) {
            setDeleteId(item?.id)
            setModal((prev) => ({ ...prev, delete: true }))
        }
    }

    const onSubmitForm = () => {
        const payload = {
            name: formValue.name,
        }

        if (actionType === ACTION_TYPE.CREATE) {
            createSopCategory(payload).then(() => {
                showToast('SOP Category berhasil dibuat')
                setModal((prev) => ({ ...prev, form: false }))
                fetchSopCategoryList()
            })
        } else {
            updateSopCategory(payload, editId).then(() => {
                showToast('SOP Category berhasil diubah')
                setModal((prev) => ({ ...prev, form: false }))
                fetchSopCategoryList()
            })
        }
    }

    const onDelete = () => {
        deleteSopCategory({ sop_category_ids: [deleteId] }).then(() => {
            showToast('SOP Category berhasil dihapus')
            setModal((prev) => ({ ...prev, delete: false }))
            setDeleteId(null)
            if (sopCategoryList?.data?.result?.length === 1 && Number(query?.page) !== 1) {
                onChangeQuery({ page: 1 })
            } else {
                fetchSopCategoryList()
            }
        })
    }

    const onBulkDelete = () => {
        setModal((prev) => ({ ...prev, delete: true }))
        setDeleteId(selectedItems.map((item) => item.id))
    }

    const onDeleteBulk = () => {
        const sop_category_ids = Array.isArray(deleteId) ? deleteId : [deleteId]
        deleteSopCategory({ sop_category_ids }).then(() => {
            showToast(`${sop_category_ids.length} SOP Category berhasil dihapus`)
            setModal((prev) => ({ ...prev, delete: false }))
            setDeleteId(null)
            setSelectedItems([])
            fetchSopCategoryList()
        })
    }

    const handleDelete = () => {
        if (Array.isArray(deleteId)) {
            onDeleteBulk()
        } else {
            onDelete()
        }
    }

    const isFormValid = () => {
        return !!(formValue.name && formValue.name.trim().length > 0)
    }

    const props = {
        dataList: sopCategoryList?.data,
        isLoading,
        query,
        onChangeQuery,
        onClickItemHandler,
        onCreateHandler,
        modal,
        setModal,
        formValue,
        onChangeName,
        actionType,
        isCreating,
        isUpdating,
        isDeleting,
        isFormValid,
        onSubmitForm,
        onDelete: handleDelete,
        toast,
        clearToast,
        selectedItems,
        onSelectItem: (items) => setSelectedItems([...items]),
        onBulkDelete,
    }

    return <SopCategory {...props} />
}
